export const THEME_BLUESTAR = 'bluestar';
export const THEME_DARKMODE = 'darkmode';
export const THEME_DEVTEST = 'devtest';
export const THEME_WORKBENCH = 'workbench';
